import { render } from "./OrderEnquiryMessages.html?vue&type=template&id=128100de&scoped=true"
import script from "./OrderEnquiryMessages.js?vue&type=script&lang=js"
export * from "./OrderEnquiryMessages.js?vue&type=script&lang=js"

import "./OrderEnquiryMessages.css?vue&type=style&index=0&id=128100de&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128100de"]])

export default __exports__